import { render, staticRenderFns } from "./RemoveStaffPopup.vue?vue&type=template&id=5957a103&scoped=true&"
import script from "./RemoveStaffPopup.vue?vue&type=script&lang=ts&"
export * from "./RemoveStaffPopup.vue?vue&type=script&lang=ts&"
import style0 from "./RemoveStaffPopup.vue?vue&type=style&index=0&id=5957a103&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5957a103",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5957a103')) {
      api.createRecord('5957a103', component.options)
    } else {
      api.reload('5957a103', component.options)
    }
    module.hot.accept("./RemoveStaffPopup.vue?vue&type=template&id=5957a103&scoped=true&", function () {
      api.rerender('5957a103', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/RemoveStaffPopup.vue"
export default component.exports